import React from 'react';

const PLACEHOLDER_IMG_URL = 'http://a.espncdn.com/watchespn/images/espn-watch-placeholder.png';

function getBaseCombinerUrl(url) {
    let combinerUrl = url.replace(/[wh]=\d*&?/g, ''); // strip off width and height params
    if (combinerUrl.indexOf('combiner') === -1 && combinerUrl.indexOf('http://a.espncdn.com') === 0) {
        combinerUrl = combinerUrl.replace('http://a.espncdn.com', 'http://a1.espncdn.com/combiner/i?img=');
    }

    return combinerUrl;
}

const ResponsiveThumbnail = (props) => {
    const url = getBaseCombinerUrl(props.src || '');

    const src = props.src;
    const srcSet = `${url}&w=135 135w,
        ${url}&w=220 220w,
        ${url}&w=280 280w,
        ${url}&w=640 640w,
        ${url} 1220w`;

    // const sizes = '(max-width: 767px) 135px, (max-width: 1023px) and (min-width: 768px) 220px, (min-width: 1280px) 280px';
    const sizes = props.sizes;
    const imgProps = (props.lazyload === true) ? {
        src: PLACEHOLDER_IMG_URL,
        'data-src': src,
        'data-srcset': srcSet,
        className: `${props.className} lazyload`
    } : { src, srcSet, className: props.className };

    return (
        <picture>
            <img {...imgProps} sizes={sizes} alt={props.alt} />
        </picture>
    );
};

ResponsiveThumbnail.propTypes = {
    alt: React.PropTypes.string,
    className: React.PropTypes.string,
    src: React.PropTypes.string,
    sizes: React.PropTypes.string,
    lazyload: React.PropTypes.bool
};

ResponsiveThumbnail.defaultProps = {
    sizes: '25vw',
    className: 'media-wrapper_image',
    lazyload: false
};

export default ResponsiveThumbnail;



// WEBPACK FOOTER //
// ./app/common/ResponsiveThumbnail.js